const weights = [3, 2, 7, 6, 5, 4, 3, 2];

function sum(digits: number[]) {
  return digits.reduce((s, d) => s + d);
}

function sumMod11(weights: number[], digits: number[]) {
  return sum(digits.map((d, i) => d * weights[i])) % 11;
}

function calculateCheckDigit(weights: number[], digits: number[]) {
  const calc = sumMod11(weights, digits);

  return calc === 0 ? 0 : 11 - calc;
}

export function validateOrganizationNumber(number: string) {
  number = number.replace(/[^\d]+/g, "");

  if (number.length !== 9) return { valid: false, length: true };

  const digits = number.split("").map(parseFloat);
  const c = digits[8];
  const base = digits.slice(0, weights.length);
  const cCalc = calculateCheckDigit(weights, base);

  if (cCalc !== c) return { valid: false, c: true };

  return { valid: true };
}
